import { getConfig } from './const'

export default {
    data () {
        return {
            page_title: "复核顺序查询",
            share_img: "https://cdn.vip-wifi.com/fangchan/config/pages/packageA/order_check/share.jpg",
            share_text: "成都购房新政资格查询，快来查查你可以买哪里~",
            qrcode_img: '',
            home_bg: '',
            home_bg_size: '',
            home_btn_pos: '',
            home_btn_size: '',
        }
    },
    async mounted () {
        const { page_title, share_img, share_text, qrcode_img, home_bg, home_bg_size, home_btn_pos, home_btn_size } = await getConfig()
        this.page_title = page_title
        this.share_img = share_img
        this.share_text = share_text
        this.qrcode_img = qrcode_img

        this.home_bg = home_bg
        this.home_bg_size = home_bg_size
        this.home_btn_pos = home_btn_pos
        this.home_btn_size = home_btn_size
    }
}